import { BP42Action } from '@r1-frontend/bp42/constants/actions';

import { TField } from '@r1-frontend/ui-react/organisms/Forms/NamePhoneForm';
import { IAction } from '@r1-frontend/shared/types/Redux';

const fillName = ({ value, isValid }: Omit<TField, 'clearInput'>): IAction<BP42Action.FillName, { value: string, isValid: boolean }> => ({
    type: BP42Action.FillName,
    payload: {
        value,
        isValid,
    },
});

export default fillName;
